var map = {
	"./backend": [
		7638,
		638
	],
	"./backend.json": [
		7638,
		638
	],
	"./contact": [
		5058,
		58
	],
	"./contact.json": [
		5058,
		58
	],
	"./database": [
		4763,
		763
	],
	"./database.json": [
		4763,
		763
	],
	"./frontend": [
		9938,
		938
	],
	"./frontend-purple": [
		2363,
		363
	],
	"./frontend-purple.json": [
		2363,
		363
	],
	"./frontend.json": [
		9938,
		938
	],
	"./home": [
		6893,
		893
	],
	"./home.json": [
		6893,
		893
	],
	"./other-tech": [
		9155,
		155
	],
	"./other-tech.json": [
		9155,
		155
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 331;
module.exports = webpackAsyncContext;